import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserComponent, UsersComponent } from './components';
import { searchEditRoutes } from '../../tms-shared';

@NgModule({
  imports: [RouterModule.forChild(searchEditRoutes(UsersComponent, UserComponent))],
  exports: [RouterModule],
})
export class UserRoutingModule {}
